"use strict";

import angular from "angular";
import uiRouter from "angular-ui-router";

import "restangular";

import errors from "dias/core/errors";
import notification from "dias/core/notification";

import FibuJournal from "./fibujournal.service";

const modelsModule = angular.module("dias.fibu.models", [
  "restangular",
  uiRouter,
  errors.name,
  notification.name
])

  .provider("FibuJournal", FibuJournal)
;

export default modelsModule;
